window.addEventListener("DOMContentLoaded", () => {
    AOS.init({
      offset: -120,
      once: true,
      mirror: false,
      duration: 1200,
      anchorPlacement: 'top-center'
    });

    gsap.registerPlugin(ScrollTrigger);

    function animateHeading(selector, delay = 100, threshold = 0.5) {
      const targets = document.querySelectorAll(selector);
      if (!targets.length) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const words = entry.target.querySelectorAll('.word');
            words.forEach((word, index) => {
              word.style.transitionDelay = `${index * delay}ms`;
              word.classList.add('in-viewport');
            });
            obs.unobserve(entry.target);
          }
        });
        }, { threshold });

        targets.forEach(target => {
          const ps = target.querySelectorAll('p');
          const elems = ps.length ? ps : [target];

          elems.forEach(ele => {
            const split = new SplitType(ele, { types: 'lines, words, chars' });

            const fragment = document.createDocumentFragment(); // 创建文档碎片
            split.lines.forEach(line => {
              const wrapper = document.createElement('div');
              wrapper.className = 'line-wrapper';
              wrapper.appendChild(line);
              fragment.appendChild(wrapper);
            });
            ele.innerHTML = '';          // 清空原有内容
            ele.appendChild(fragment);   // 一次性插入，减少重排

            requestAnimationFrame(() => target.classList.add('ready'));

            observer.observe(ele);
          });
        });
    }
    animateHeading('.animatedHeading', 100, 0.5);
    // function animateHeading(selector, delay = 100, threshold = 0.5) {
    //   const targets = document.querySelectorAll(selector);
    //   console.log('加载出来qwdwqdqw');

    //   if (!targets.length) return;
      
    //   targets.forEach(target => {
    //     const ps = target.querySelectorAll('p');
    //     const elements = ps.length ? ps : [target]; 
      
    //     elements.forEach(ele => {
    //       const split = new SplitType(ele, { types: 'lines, words, chars' });
      
    //       split.lines.forEach(line => {
    //         const wrapper = document.createElement('div');
    //         wrapper.className = 'line-wrapper';
    //         line.replaceWith(wrapper);
    //         wrapper.appendChild(line);
    //       });

    //       requestAnimationFrame(() => {
    //         target.classList.add("ready");
    //       });
      
    //       const words = ele.querySelectorAll('.word');
      
    //       const observer = new IntersectionObserver((entries, obs) => {
    //         entries.forEach(entry => {
    //           if (entry.isIntersecting) {
    //             words.forEach((word, index) => {
    //               setTimeout(() => {
    //                 word.classList.add('in-viewport');
    //               }, index * 100); 
    //             });
    //             obs.disconnect();
    //           }
    //         });
    //       }, { threshold: 0.5 });
      
    //       observer.observe(ele);
    //     });
    //   });
      
    //   $('body').addClass('a-test')
    // }

    // animateHeading('.animatedHeading', 100, 0.5);

    function initFullscreenVideos() {
      const videos = document.querySelectorAll(".fullscreen-video");
      const isPc = window.innerWidth > 1024;

      videos.forEach(video => {
        const pcSrc = video.getAttribute("data-pc-video");
        const mobSrc = video.getAttribute("data-mobile-video");

        if (!pcSrc && !mobSrc) return;

        // 创建 source
        const source = document.createElement("source");
        source.src = isPc ? pcSrc : mobSrc;
        source.type = "video/mp4";

        // 清空旧的 <source>，避免重复
        video.innerHTML = "";
        video.appendChild(source);
        // 加载并播放
        video.load();
        video.play().catch(err => {
          console.warn("自动播放被阻止，需要用户交互:", err);
        });
      });
    }

    initFullscreenVideos();

    function playVideo(){
      const body = $('body');

      function showVideo(videoSrc, trackConfigs) {
			let trackHtml = "";
			if(trackConfigs && trackConfigs.length > 0) {
				const t1HTML = `
							<track src="${trackConfigs[0].src}" kind="${trackConfigs[0].kind}" srclang="${trackConfigs[0].srclang}" label="${trackConfigs[0].label}" 
								mode="hidden">`;
				trackHtml += t1HTML;
			}
			if(trackConfigs && trackConfigs.length > 1) {
				const t2HTML = `
							<track src="${trackConfigs[1].src}" kind="${trackConfigs[1].kind}" srclang="${trackConfigs[1].srclang}" label="${trackConfigs[1].label}" 
								mode="hidden">`;
				trackHtml += t2HTML;
			}
        const videoHtml = `
          <div class="video-fixed">
            <div class="video-popover">
              <video muted controls autoplay loop>
                <source src="${videoSrc}" type="video/mp4">${trackHtml}
              </video>
            </div>
      
            <button class="video-popover-close fs-20 div-like">
              <svg aria-hidden="true" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2131" width="200" height="200"><path d="M895.156706 86.256941a30.177882 30.177882 0 0 1 42.767059-0.180706c11.745882 11.745882 11.745882 30.870588-0.180706 42.767059L128.843294 937.743059c-11.866353 11.866353-30.930824 12.047059-42.767059 0.180706-11.745882-11.745882-11.745882-30.870588 0.180706-42.767059L895.156706 86.256941z" fill="#000000" p-id="2132"></path><path d="M86.076235 86.076235c11.745882-11.745882 30.870588-11.745882 42.767059 0.180706l808.899765 808.899765c11.866353 11.866353 12.047059 30.930824 0.180706 42.767059-11.745882 11.745882-30.870588 11.745882-42.767059-0.180706L86.256941 128.843294a30.177882 30.177882 0 0 1-0.180706-42.767059z" fill="#000000" p-id="2133"></path><path d="M0 0h1024v1024H0z" fill="#FFF4F4" fill-opacity="0" p-id="2134"></path></svg>
            </button>
          </div>`;
    
        body.append(videoHtml);
        $('.video-fixed').fadeIn(200);
      }

      function closeVideo() {
        $('.video-fixed').fadeOut(200).remove();
      }

      body.on('click', '.js-video', function () {
        let videoSrc = $(this).data('pvideo');
        let cfg1 = { src: $(this).data('t1Src'), kind: $(this).data('t1Kind'), srclang: $(this).data('t1Srclang'), label: $(this).data('t1Label') };
        let cfg2 = { src: $(this).data('t2Src'), kind: $(this).data('t2Kind'), srclang: $(this).data('t2Srclang'), label: $(this).data('t2Label') };
        if( $(window).width() < 1025 ){
          videoSrc = $(this).data('mvideo');
          cfg1 = { src: $(this).data('t1mSrc'), kind: $(this).data('t1Kind'), srclang: $(this).data('t1mSrclang'), label: $(this).data('t1mLabel') };
          cfg2 = { src: $(this).data('t2mSrc'), kind: $(this).data('t2Kind'), srclang: $(this).data('t2mSrclang'), label: $(this).data('t2mLabel') };
        }
        if (!videoSrc) return;
        showVideo(videoSrc, [cfg1, cfg2]);
      });
    
      body.on('click', '.video-popover-close', closeVideo);
    }
    playVideo();

    function travelAnimation() {
      if (!$('.noes2u-travel').length) return;
      const travelSection = document.querySelector('.noes2u-travel');
      const travelImage = travelSection.querySelector('.noes2u-travel-image .ani');
      const introText = travelSection.querySelector('.noes2u-travel-intro');
      let scaleX = 0.39;
      let scaleY = 0.39;

      if ($(window).width() < 1025) {
        scaleX = 0.8;
        scaleY = 0.5; // 这里可以自己调，和 scaleX 不一样
      }

      gsap.set(travelImage, {
        scaleX: scaleX,
        scaleY: scaleY,
        borderRadius: "50px"
      });
      gsap.set(introText, { opacity: 0, y: 50 });

      // 用 timeline 管理动画
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.noes2u-travel-scroll',
          start: "top top",
          end: "bottom bottom",
          scrub: true,
        }
      });

      tl.to(travelImage, { scale: 1, ease: "none" }) // 图片放大
        .to(travelImage, { borderRadius: "0px", ease: "power1.out" }, 0.9) // 在 90% 进度时变圆角
        .to(introText, { opacity: 1, y: 0, ease: "power1.out" }, 0.8); // 在 80% 进度时显示文字

      
    }
    travelAnimation();

    function initProgressCounters() {
      if (!$('.noes2u-clean-card__handle').length) return;
      const handles = document.querySelectorAll('.noes2u-clean-card__handle');

      handles.forEach(handle => {
        const progressEl = handle.querySelector('.noes2u-clean-card__progress-bar');

        if (!progressEl) return;

        // 读取目标值
        const targetValue = parseInt(progressEl.dataset.value, 10);

        // 确保初始化宽度为 0%
        progressEl.style.width = '0%';

        // IntersectionObserver
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
            // 数字动画
            const obj = { val: 0 };
            gsap.to(obj, {
              val: targetValue,
              duration: 1.5,
              ease: "power1.out",
              
            });

            // 进度条动画
            gsap.to(progressEl, {
              width: `${targetValue}%`,
              duration: 1.5,
              ease: "power1.out"
            });

            // 触发一次后取消观察
            obs.unobserve(entry.target);
            }
          });
        }, {
          root: null,
          rootMargin: '0px 0px -20% 0px', // 提前触发，可根据需求调节
          threshold: 0 // 只要有一点进入视口就触发
        });

        observer.observe(handle);
      });
    }
    initProgressCounters();

    function initDifferentCards(selector = '.noes2u-different-card') {
      if (!$('.noes2u-different-card').length) return;
      document.querySelectorAll(selector).forEach(card => {
        const swiperEl = card.querySelector('.noes2u-different-swiper');
        const dots = card.querySelectorAll('.noes2u-different-dot');
        const paths = card.querySelectorAll('.progress-path'); // 每个card独立找

        if (!swiperEl || dots.length === 0 || paths.length === 0) return;

        let current = 0;
        let pathTween = null;

        // 初始化 Swiper
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          effect: 'fade',
        });

        // 播放进度条动画
        function animatePath(index) {
          const path = paths[index];
          if (!path) return;

          if (pathTween) pathTween.kill();

          // 重置所有path
          paths.forEach(p => gsap.set(p, { strokeDashoffset: 307 }));

          // 播放当前path动画
          pathTween = gsap.to(path, {
            strokeDashoffset: 0,
            duration: 1.2,
            ease: 'linear',
            onComplete: () => {
              // current++;
              // if (current >= paths.length) current = 0;
              // swiper.slideTo(current); 
              // animatePath(current);
            }
          });
        }

        // 初始化第一个
        animatePath(current);

        // Swiper 切换时更新 dot 和 current
        swiper.on('slideChange', () => {
          dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === swiper.realIndex);
          });
          current = swiper.realIndex;
          animatePath(current); // 切换时重启动画
        });

        // 点击 dot 切换
        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => {
            swiper.slideTo(i);
            animatePath(i);
          });
          if(window.handleKeyPress2026_v1) {
            window.handleKeyPress2026_v1(dot, function(){ $(dot).trigger('click') });
          }
        });
      });
    }

    initDifferentCards();

    
    if( $('.noes2u-storie-swiper').length){
      const swiper = new Swiper('.noes2u-storie-swiper', {
        slidesPerView: 'auto',   
        // spaceBetween: 20,        
        // slidesOffsetBefore: 100, 
        slidesOffsetAfter: 0,    
        centeredSlides: false,  
        speed: 800,
        loop: true,
        autoplay: {
          delay: 3000, 
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.noes2u-storie-next', 
          prevEl: '.noes2u-storie-prev',
        },
      });
    }


    $('.noes2u-use-tab li').on('click', function(){
      $(this).addClass('active').siblings().removeClass('active');
      $('.noes2u-use-item').eq($(this).index()).fadeIn().siblings().hide();
      $(this).attr('aria-selected','true').siblings().attr('aria-selected','false');
    })


    async function technologyAnimation() {
      if (!$('.noes2u-technology-images').length) return;
      const zipUrl = 'https://cdn.shopify.com/s/files/1/0503/2024/4926/files/sequence.zip?v=1759984710'; 
      const container = document.querySelector(".noes2u-technology-media");
      const imageWrap = document.querySelector(".noes2u-technology-images");


      // 1️⃣ 加载并解压 ZIP 文件
      const response = await fetch(zipUrl);
      const blob = await response.blob();
      const zip = await JSZip.loadAsync(blob);
      const files = Object.keys(zip.files)
        .filter(name => name.endsWith('.webp') || name.endsWith('.jpg') || name.endsWith('.png'))
        .sort((a, b) => {
          // 按数字顺序排序
          const numA = parseInt(a.match(/\d+/));
          const numB = parseInt(b.match(/\d+/));
          return numA - numB;
        });

      // 2️⃣ 逐帧生成图片
      for (let name of files) {
        const fileData = await zip.file(name).async('base64');
        const img = document.createElement('img');
        img.setAttribute("alt", "bristle technology frame");
        img.src = `data:image/webp;base64,${fileData}`;
        imageWrap.appendChild(img);
      }

      const wrapper = document.querySelector(".noes2u-technology");
      const lines = container.querySelectorAll(".noes2u-technology-branch");

      // 3️⃣ 等待图片渲染完成后执行动画
      const images = container.querySelectorAll(".noes2u-technology-images img");
      const frameCount = images.length;
      let obj = { frame: 0 };

      gsap.to(obj, {
        frame: frameCount - 1,
        snap: "frame",
        ease: "none",
        scrollTrigger: {
          trigger: ".noes2u-technology",
          start: "top top",
          end: "bottom bottom",
          scrub: true,
          onUpdate: (self) => {
            images.forEach((img, i) => {
              img.style.opacity = i === obj.frame ? 1 : 0;
            });

            lines.forEach(branch => {
								const lineCur = branch.querySelector(".item-line-cur");
								const lineValue = branch.querySelector(".item-line-value");
								const text = branch.querySelector(".item-text");
								if (lineCur && lineValue) {
									const targetWidth = lineValue.offsetWidth;
									const progress = self.progress; // 0 ~ 1
									const currentWidth = targetWidth * progress;
									// lineCur.style.width = currentWidth + "px";
									// 当进度超过 95% 再显示文字
									if (progress >= 0.95) {
										gsap.to(lineCur, { width: targetWidth, duration: 0.5 });
										gsap.to(text, { opacity: 1, y: 0, duration: 0.5 });
									}else{
										gsap.to(lineCur, { width: 0, duration: 0.5 });
										gsap.to(text,{ opacity: 0, y: -10, duration: 0.5 });
									}
								}
						});
          }
        }
      });
    }
    technologyAnimation();


    
    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });

});